<template>
    <HomePage></HomePage>
</template>
<script setup>
import HomePage from '@/views/HomePage.vue'
</script>
